import { useCallback } from "react";
import api, { openApi } from "../../services/api";

const targetId = value => {
    if (!/^[1-9]\d*$/.test(String(value)) || !Number.isSafeInteger(Number(value))) throw new Error("Selecione um plano válido");
    return Number(value);
};
const usePlans = () => {

    const getPlanList = async (params) => {
        const { data } = await openApi.request({
            url: '/plans/list',
            method: 'GET',
            params
        });
        return data;
    }

    const list = async (params, config = {}) => {
        const { data } = await api.request({
            ...config,
            url: '/plans/all',
            method: 'GET',
            params
        });
        return data;
    }

    const save = async (data) => {
        if (data.id !== undefined) throw new Error("Novo plano não pode ter um ID existente");
        const { data: responseData } = await api.request({
            url: '/plans',
            method: 'POST',
            data
        });
        return responseData;
    }

    const update = async (data) => {
        const id = targetId(data.id);
        const { id: ignoredId, ...fields } = data;
        const { data: responseData } = await api.request({
            url: `/plans/${id}`,
            method: 'PUT',
            data: fields
        });
        return responseData;
    }

    const remove = async (id) => {
        const { data } = await api.request({
            url: `/plans/${targetId(id)}`,
            method: 'DELETE'
        });
        return data;
    }

    const getPlanCompany = useCallback(async (params, id) => {
        const { data } = await api.request({
            url: `/companies/listPlan/${id}`,
            method: 'GET',
            params
        });
        return data;
    }, []);

    return {
        getPlanList,
        list,
        save,
        update,
        remove,
        getPlanCompany
    }
}

export default usePlans;
